const storageKey = "keyboard.gridCoachmarkSeen";

export const readGridCoachmarkSeen = (): boolean => {
	try {
		return localStorage.getItem(storageKey) === "true";
	} catch {
		return false;
	}
};

export const writeGridCoachmarkSeen = (): void => {
	try {
		localStorage.setItem(storageKey, "true");
	} catch {
		// QuotaExceededError — storage full, the coachmark simply shows again next session
	}
};
